import Button from '../../../../../Button'
import React from 'react'

const ShowActiveNameFilter = ({ filterName, t }) => {
  return (
    <Button
      className='show-active-filter-name'
      id=''
      disabled
      kind='secondary'
      size='default'
      type='button'
    >
      {t('TableActions.ShowActiveNameFilter.NAME_FILTER', { filterName })}
    </Button>
  )
}

export default ShowActiveNameFilter
